import { render, staticRenderFns } from "./VideoItem4.vue?vue&type=template&id=b1b7f92e"
import script from "./VideoItem4.vue?vue&type=script&lang=js"
export * from "./VideoItem4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports